import React, { Fragment, useContext, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useLocation } from "react-router";
import { Card, CardBody, Col, Container, DropdownItem, Row } from "reactstrap";
import SharedDataContext from "../../../_helper/SharedData";
import { Breadcrumbs, Spinner } from "../../../AbstractElements";
import { vendorCarCurrentStatusColumns, vendorCarCurrentStatusFilterColumns } from "../../../Data/Vendor/VendorList";
import { getCarDetail } from "../../../Services/Car.service";
import {
    getAllCarTypes,
    getUserDetails,
    showAlert,
} from "../../../Services/Shared.service";
import { getCabAndDriverForVendor, getCabAndDriverForVendorWithFilter, getCabAndDriverForVendorWithSearchFilter } from "../../../Services/Ventor.service";
import DeleteConfirmationModal from "../../Car/DeleteConfirmationModal";
import ActionOptions from "../../Common/Component/ActionOptions";

import SearchTable from "../../Common/Component/SearchTable";
import SelectedFilter from "../../Inventory/CarListing/SelectedFilter";
import CustomizerContext from "../../../_helper/Customizer";
import FilterTable from "./Components/FilterTable";

const CarCurrentStatus = () => {

    const location = useLocation();
    const userDetails = getUserDetails();
    const { mix_background_layout } = useContext(CustomizerContext)

    const [pagination, setPagination] = useState(location.state?.pageNumber ? location.state.pageNumber : 0);
    const [searchData, setSearchData] = useState(location.state?.searchdata ? location.state?.searchdata : "");
    const [loader, setLoader] = useState(false);
    const [cabData, setCabData] = useState([]);
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);
    const { globalCityField, setShowApiLoader, setPageNumber, dateFilter } = useContext(SharedDataContext);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [filterData, setFilterData] = useState(location.state?.filterdata?.length > 0 ? location.state?.filterdata : []);
    const [filterType, setFilterType] = useState(location.state?.filterdata?.length > 0 ? "filter" : location.state?.searchdata ? "search" : "");

    const [editTripModal, setEditTripModal] = useState(false);
    const [deleteVendorCabObj, setDeleteVendorCabObj] = useState({});
    const [vendorCabObj, setVendorCabObj] = useState({});
    const [carId, setCarId] = useState(false)
    const [deleteCabModal, setDeleteCabModal] = useState(false)
    const [carTypeData, setCarTypeData] = useState([])

    const toggleEditCabModal = () => setEditTripModal(!editTripModal)
    const toggleDeleteCabModal = () => setDeleteCabModal(!deleteCabModal)

    useEffect(() => {
        console.log(">>>> fetcing Car Data value");
        fetchCarData({ isSearchFilterPage: 0 });
    }, [searchData, filterData, filterType]);

    useEffect(() => {
        if (carId !== false) {
            getCarDetail(carId).then((response) => {
                setVendorCabObj(response.data);
            });
        }
    }, [deleteCabModal, editTripModal])

    const removeFilter = (index) => {
        const newfilterData = [...filterData];
        newfilterData.splice(index, 1);
        setFilterData(newfilterData);
    };

    const columns = vendorCarCurrentStatusFilterColumns.map((element) => {
        return {
            value: {
                name: element.name,
                value: element.value,
                type: element.type,
            },
            label: element.name,
        };
    });

    const onChangeRowsPerPage = (currentRowsPerPage) => {
        setRowsPerPage(currentRowsPerPage);
    };

    const onChangePage = (page) => {
        setPagination(page - 1);
    };

    const disableLoaders = () => {
        setLoader(false);
    };

    const fetchCarData = async () => {

        console.log(">>>>> filted Data >>>> ", filterData.length);

        const serviceCityId = globalCityField.value?.id || 0;
        const aggregatorId = userDetails.aggregatorId || 0;

        let carType = null;
        let carNo = null;
        let driverName = null;
        let status = null;

        if (filterData.length > 0) {
            filterData.forEach((value) => {

                console.log(">>>>>>>>>>>>>>>>>>>>>");

                if (value.column_name === "carType") {
                    console.log("??????? ", value.values[0]);
                    carType = value.values[0];
                }
                else if (value.column_name === "carNo") {
                    console.log("??????? ", value.values[0]);
                    carNo = value.values[0];
                }
                else if (value.column_name === "driverName") {
                    console.log("??????? ", value.values[0]);
                    driverName = value.values[0];
                }
                else if (value.column_name === "status") {
                    console.log("??????? ", value.values[0]);
                    status = value.values[0];
                }
            })
        }

        if (filterData.length == 0 && !searchData) {
            console.log("filter is zero and searchdata is false");

            const obj = {
                aggregatorId: aggregatorId ? aggregatorId : 0,
                serviceCityId: serviceCityId ? serviceCityId : 0,
            };
            setLoader(true);
            getCabAndDriverForVendor(obj)
                .then((result) => {
                    setCabData(result.data.list);
                    setPaginationTotalRows(result.data.count);
                    disableLoaders();
                })
                .catch((err) => {
                    disableLoaders();
                    setCabData([]);
                    showAlert("error", err.response.data.message ? err.response.data.message : "Something went wrong")
                });
        }
        else if (filterData.length > 0 && filterType == "filter") {
            console.log(">>>>>>> 2 nd value")
            let obj = {
                aggregatorId: aggregatorId ? aggregatorId : 0,
                serviceCityId: serviceCityId ? serviceCityId : 0,
                carNo : carNo,
                driverName : driverName,
                carType : carType,
                status : status,
                page: pagination.page,
                size: pagination.rowsPerPage,
            };

            filterData.forEach((d) => {
                obj[d.column_name] = d["values"][0];
            });

            // TODO : CHANGE THE BELOW API FOR FILTER BASED SEARCH.
            getCabAndDriverForVendorWithFilter(obj).then((res) => {
                if (res.data) {
                    console.log(">>>>>>> RESPONSE DATA ::: ", res.data);
                    setCabData(res.data.list)
                    setPaginationTotalRows(res.data.count);
                    disableLoaders();
                }
            }).catch((err) => {
                console.log(err)
                setCabData([])
                disableLoaders();
                // showAlert("error", err.response.data.message ? err.response.data.message : "Something went wrong")
            })
        } else if (searchData && filterType == "search") {
            // Add search filter condition api
            console.log(">>>>>>> 3 rd value")

            getCabAndDriverForVendorWithSearchFilter(searchData).then((res) => {
                if (res.data) {
                    console.log(">>>>>>> RESPONSE DATA ::: ", res.data);
                    setCabData(res.data.list)
                    setPaginationTotalRows(res.data.count);
                    disableLoaders();
                }
            }).catch((err) => {
                setCabData([])
                disableLoaders();
                showAlert("error", err.response.data.message ? err.response.data.message : "Something went wrong")
            })
        }
    };

    useEffect(() => {
        getCars()
        // fetchAggregatorsList()
    }, []);

    const getCars = () => {
        let obj = {
            page: 0,
            size: 30
        };
        getAllCarTypes(obj)
            .then((result) => {
                const data = result?.data?.content.map((element) => {
                    return {
                        label: element.name,
                        value: element.id,
                    };
                });
                setCarTypeData(data);
            })
            .catch((err) => {
                showAlert("error", err.response.data.message ? err.response.data.message : "Unable to fetch Car details for selected City")
            });
    }

    const processData = cabData.map((element, index) => {
        return {
            driver_name: element.driverName ? element.driverName : "-",
            cab_number: element.carNo ? element.carNo : "-",
            cab_type: element.carType ? element.carType : "-",
            service_city: element.serviceCityId ? element.serviceCityId : '-',
            status: element.status ? element.status : "-",
            driver_is_available: element.driverIsAvailable ? "Available" : "Not Available",
            driver_is_deleted: element.driverIsDeleted,
            cab_is_deleted: element.cabIsDeleted,
            action:
                <ActionOptions>
                    <DropdownItem
                        className="border-0"
                        key={"row-edit"}
                        onClick={() => {
                            setCarId(element.carId);
                            toggleEditCabModal();
                        }}
                    >
                        <i className="fa fa-pencil"></i> Edit
                    </DropdownItem>

                    <DropdownItem
                        className="border-0"
                        key={"row-delete"}
                        onClick={() => {
                            setCarId(element.carId);
                            setDeleteVendorCabObj(element);
                            toggleDeleteCabModal()
                        }}
                    >
                        <i className="fa fa-trash"></i> {element.driverIsDeleted ? "Recover" : "Delete"}
                    </DropdownItem>
                </ActionOptions>
        }
    })

    const conditionalRowStyles = [

        {
            when: row => row["driver_is_deleted"],
            style: row => ({ backgroundColor: row["driver_is_deleted"] ? "#F9B5A6" : "" }),
        },
    ];
    return (
        <Fragment>
            <Breadcrumbs
                parent="Vendor"
                mainTitle="Vendor"

                span1={
                    <FilterTable
                        options={columns}
                        setFilterData={setFilterData}
                        filterData={filterData}
                        setFilterType={setFilterType}
                        setSearchData={setSearchData}
                        carTypeData={carTypeData}
                        statusData={[
                            { value: "OffLine", label: "OffLine" },
                            { value: "OnLine", label: "OnLine" },
                            { value: "Assigned", label: "Assigned" },
                            { value: "AirportZone", label: "AirportZone" },
                            { value: "Logout", label: "Logout" },
                            { value: "Blocked", label: "Blocked" },
                            { value: "LogIn", label: "LogIn" },
                            { value: "OnTrip", label: "OnTrip" },
                        ]}
                    />
                }

                span3={
                    <SearchTable
                        searchData={searchData}
                        setSearchData={setSearchData}
                        setFilterData={setFilterData}
                        setFilterType={setFilterType}
                        placeholder={"Search"}
                    />
                }
            />
            <Container fluid={true} className="datatables">
                <Row className="selected-filter">
                    {filterData.map((element, i) => {
                        return (
                            <SelectedFilter
                                key={i}
                                element={element}
                                index={i}
                                removeFilter={removeFilter}
                            />
                        );
                    })}
                </Row>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody className="p-0">
                                <DataTable
                                    columns={vendorCarCurrentStatusColumns}
                                    data={processData}
                                    center={true}
                                    fixedHeader
                                    fixedHeaderScrollHeight={"57vh"}
                                    pagination
                                    paginationTotalRows={paginationTotalRows}
                                    conditionalRowStyles={conditionalRowStyles}
                                    onChangePage={onChangePage}
                                    onChangeRowsPerPage={onChangeRowsPerPage}
                                    paginationServer
                                    progressPending={loader}
                                    progressComponent={
                                        <div className="loader-box" style={{ height: "57vh" }}>
                                            <Spinner
                                                attrSpinner={{
                                                    className: "loader-3",
                                                    style: {
                                                        width: "30px",
                                                        height: "30px",
                                                        borderColor: "#39B54A",
                                                        borderBottomColor: "transparent",
                                                    },
                                                }}
                                            />
                                        </div>
                                    }
                                    theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <DeleteConfirmationModal
                Large={deleteCabModal}
                title={"Delete Cab"}
                LargeModaltoggle={toggleDeleteCabModal}
                fetchData={fetchCarData}
                carObj={vendorCabObj}
            />
        </Fragment>
    );
}

export default CarCurrentStatus;